import React, { useState } from "react";
import {
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  InputGroup,
  ModalFooter,
  Col,
} from "reactstrap";
import { Formik, Form, Field } from "formik";
import { ShareIcon } from "@heroicons/react/20/solid";
import {
  RenderButton,
  RenderTextFieldWithoutAutoComplete,
  SubmitButton,
} from "components";
import { addSharedUser, removeSharedUser } from "../actions";
import { connect } from "react-redux";
import "../index.scss";

const ShareListModal = ({
  loginUser,
  addSharedUserAction,
  removeSharedUserAction,
  creatorList,
  isOpen,
  toggleModal,
  ...props
}) => {
  const [emailAddress, setEmailAddress] = useState("");

  const addSharedUserHandler = () => {
    addSharedUserAction({
      _id: creatorList._id,
      name: creatorList.name,
      shareWithEmail: emailAddress,
    });
    setEmailAddress("");
  };

  const removeSharedUserHandler = (user_id) => {
    removeSharedUserAction({
      _id: creatorList._id,
      shareWithUser_id: user_id,
    });
  };

  const sharedUserCol = (user, isOwner) => (
    <Col className="col-12 mt-2 user">
      <h2>{user.name}</h2>
      <p className="user-email">{user.email}</p>
      {isOwner ? (
        <span className="user-owner">Owner</span>
      ) : (
        <button
          type="button"
          className="close remove-button"
          aria-label="Remove user"
          onClick={() => removeSharedUserHandler(user._id)}
        >
          <span aria-hidden="true">&times;</span>
        </button>
      )}
    </Col>
  );

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggleModal}
      wrapClassName="share-list-modal"
      contentClassName="share-list-content"
      centered
    >
      <ModalHeader>
        <Row className="d-flex align-items-center">
          <span className="export-icon mr-3">
            <ShareIcon width={25} height={25} strokeWidth={5} />
          </span>
          Share "{creatorList.name}"
        </Row>
      </ModalHeader>
      <ModalBody className="share-modal mb-3">
        <Row>
          <Formik onSubmit={addSharedUserHandler}>
            {() => (
              <Form className="share-list-form mt-2 mb-4">
                <InputGroup className="d-flex align-items-center">
                  <Field
                    autoFocus
                    id="share-list-field"
                    name="shareEmail"
                    className="col-12"
                    placeholder="Enter email address..."
                    customvalue={emailAddress}
                    onChange={(e) => {
                      setEmailAddress(e.target.value);
                    }}
                    component={RenderTextFieldWithoutAutoComplete}
                  />

                  <SubmitButton
                    color="primary"
                    className="ml-3 share-button"
                    disabled={!emailAddress}
                  >
                    Share
                  </SubmitButton>
                </InputGroup>
              </Form>
            )}
          </Formik>
          <div className="shared-users">
            <h1>People with access</h1>
            <Row className="mx-0">
              {sharedUserCol(loginUser, true)}
              {creatorList?.sharedWithUser_ids.map((user) =>
                sharedUserCol(user, false)
              )}
            </Row>
          </div>
        </Row>
      </ModalBody>
      <ModalFooter className="d-flex justify-content-end mb-3">
        <RenderButton className="btn btn-primary" onClick={toggleModal}>
          Close
        </RenderButton>
      </ModalFooter>
    </Modal>
  );
};

const mapStateToProps = (state) => {
  return {
    loginUser: state.login.loginUser,
  };
};

export default connect(mapStateToProps, {
  addSharedUserAction: addSharedUser,
  removeSharedUserAction: removeSharedUser,
})(ShareListModal);
